import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  CardContent,
  Select,
  MenuItem,
  Typography,
  Box,
  Container,
  Grid,
  FormControl,
  InputLabel,
} from "@mui/material";
import ProductList from "./product_select";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../../redux/loader/actions";
import productMappingApi from "../../../services/product_mapping";
import productApi from "../../../services/product";
import Communication from "./communication";

const ProductMapping = () => {
  const dispatch = useDispatch();
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedProductUUID, setSelectedProductUUID] = useState("");
  const [showProductList, setShowProductList] = useState(false);
  const [planDetails, setPlanDetails] = useState([]);
  const [productList, setProductList] = useState([]);

  const handleProductChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedProduct(selectedValue);


    if (selectedValue === "Communication Channel") {
      setShowProductList(false);
      setSelectedProductUUID("");
    } else {
      setShowProductList(true);
      const selectedProductItem = productList.find(
        (product) => product.name === selectedValue
      );

      if (selectedProductItem) {
        setSelectedProductUUID(selectedProductItem.uuid);
      }
    }
  };

  const productSelect = useCallback(() => {
    dispatch(showLoader());

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setProductList(res?.data?.data);
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Error response:", err);
    };

    productApi.getAllProduct().then(onSuccess).catch(onFailure);
  }, [dispatch]);

  useEffect(() => {
    productSelect();
  }, [productSelect]);

  const productData = useCallback(
    (uuid) => {
      dispatch(showLoader());

      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          setPlanDetails(res?.data?.data);
        }
      };

      const onFailure = (err) => {
        dispatch(hideLoader());
        console.error("Error response:", err?.response?.msg);
        setShowProductList(false);
        if (err?.response?.status === false) {
          setPlanDetails([]);
        }
      };

      productMappingApi.getAllProductData(uuid).then(onSuccess).catch(onFailure);
    },
    [dispatch]
  );

  useEffect(() => {
    if (selectedProductUUID) {
      productData(selectedProductUUID);
    }
  }, [selectedProductUUID, productData]);

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: "4" }}>
        <Typography variant="h6" gutterBottom>
          Product Mapping
        </Typography>
        <Box sx={{ margin: "auto", marginTop: "10px", maxWidth: "100%" }}>
          <Card sx={{ marginBottom: 2, width: "100%" }} elevation={3}>
            <CardContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item md={4} sm={12}>
                  <FormControl fullWidth>
                    {selectedProduct && (
                      <InputLabel id="product-select-label">
                        Select a product
                      </InputLabel>
                    )}
                    <Select
                      labelId="product-select-label"
                      value={selectedProduct}
                      onChange={handleProductChange}
                      displayEmpty
                      fullWidth
                      sx={{ marginTop: 1 }}
                    >
                      <MenuItem value="" disabled>
                        Select a product
                      </MenuItem>
                      {productList.map((product) => (
                        <MenuItem key={product.uuid} value={product.name}>
                          {product.name}
                        </MenuItem>
                      ))}
                      <MenuItem value="Communication Channel">
                        Communication Channel
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Box>
      </Container>
      {selectedProduct === "Communication Channel" ? (
        <Communication />
      ) : showProductList && planDetails?.data?.length > 0 ? (
        <ProductList
          planDetails={planDetails?.data}
          uuid={selectedProductUUID}
          handleProductChange={handleProductChange}
          selectedProduct={selectedProduct}
          selectedProductUUID={selectedProductUUID}
        />
      ) : (
        <Container maxWidth="xl">
          <Card elevation={3}>
            <Box p={2}>
              <Typography variant="subtitle2" sx={{ textAlign: "center" }}>
                No Data Found
              </Typography>
            </Box>
          </Card>
        </Container>
      )}
    </>
  );
};

export default ProductMapping;
